import { useFormatter } from "use-intl";

/** "+N" suffix for card previews that show only part of a list. */
export function EntityAboutMore({ count }: { count: number }) {
  const format = useFormatter();
  if (count <= 0) return null;
  return <span className="shrink-0 text-muted-foreground">+{format.number(count)}</span>;
}
